export const calculateOffsetLimit = (configs, total = 0) => {
  let { pageNumber, pageLimit } = configs;
  let offset = pageNumber ? (pageNumber - 1) * pageLimit : 0;
  if (total) {
    while (offset > 0 && offset >= total) {
      offset--;
    }
  }
  return {
    limit: pageLimit,
    offset: offset,
    ...(({ pageNumber, pageLimit, ...otherKeys }) => ({ ...otherKeys }))(
      configs
    ),
  };
};
